var _jsxFileName = "/repo/packages/ippm/src/components/Feature/index.js",
  _this = this;
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { IconCheckCircle, IconXCircle } from '@sm/wds-icons';
import './feature.scss';
var Feature = function Feature(_ref) {
  var label = _ref.label,
    included = _ref.included,
    className = _ref.className,
    customFeature = _ref.customFeature;
  var cls = classNames('plan-feature', 'wds-m-r-3', customFeature ? 'wds-m-b-3' : 'wds-m-b-4', 'wds-m-l-4', 'wds-type--left', className, {
    included: included
  });
  var renderIcon = function renderIcon() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, included ? /*#__PURE__*/React.createElement("span", {
      className: "wds-type wds-type--primary plan-feature__icon",
      "data-testid": "check-circle",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 23,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(IconCheckCircle, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 13
      }
    })) : null, !included ? /*#__PURE__*/React.createElement("span", {
      className: "wds-type wds-type--dark-muted plan-feature__icon",
      "data-testid": "x-circle",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 31,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(IconXCircle, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 13
      }
    })) : null);
  };
  return /*#__PURE__*/React.createElement("li", {
    className: cls,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-feature__label",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 7
    }
  }, renderIcon(), label));
};
Feature.defaultProps = {
  className: '',
  included: false,
  customFeature: false
};
Feature.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  included: PropTypes.bool,
  customFeature: PropTypes.bool
};
export default Feature;